export default "__VITE_ASSET__CfZALIE5__"